import { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user !== false && user.role) {
    return <Navigate to="/admin" replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back, Su.");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-alabaster flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <Link to="/" className="font-serif text-2xl text-onyx block mb-2" data-testid="login-logo">
          Onyx <span className="text-ochre">&amp;</span> Ochre
        </Link>
        <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-onyx-muted mb-10">
          Studio Login
        </p>
        <form onSubmit={submit} data-testid="login-form" className="space-y-6">
          <div>
            <label className="font-mono text-[10px] tracking-[0.2em] uppercase text-onyx-muted">
              Email
            </label>
            <input
              type="email"
              data-testid="login-email"
              className="w-full bg-transparent border-b border-[#CFD3DE] focus:border-ochre outline-none py-2 font-sans text-onyx transition-colors"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div>
            <label className="font-mono text-[10px] tracking-[0.2em] uppercase text-onyx-muted">
              Password
            </label>
            <input
              type="password"
              data-testid="login-password"
              className="w-full bg-transparent border-b border-[#CFD3DE] focus:border-ochre outline-none py-2 font-sans text-onyx transition-colors"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full font-sans uppercase text-xs tracking-[0.2em] bg-onyx text-alabaster py-4 hover:bg-ochre transition-colors disabled:opacity-50"
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
